export const getDeliveryApiBaseUrl = (): string => {
  return import.meta.env.VITE_DELIVERY_BE_URL
}
